var map = {
	"./analytics/App": [
		1053,
		0
	],
	"./controls/App": [
		1054,
		1
	],
	"./dataforwards/App": [
		1055,
		4
	],
	"./kits/App": [
		1056,
		2
	],
	"./template/App": [
		1057,
		6
	],
	"./vmeter/App": [
		1058,
		3
	],
	"./weather/App": [
		1059,
		5
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 563;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/apps lazy ^\.\/.*\/App$
// module id = 563
// module chunks = 7